import React from 'react';
import { Link } from 'react-router-dom';
import ModernHeader from '../components/modern/ModernHeader';
import HeroSection from '../components/modern/HeroSection';
import KPIGrid from '../components/modern/KPIGrid';
import Timeline from '../components/modern/Timeline';
import Services from '../components/modern/Services';
import Portfolio from '../components/modern/Portfolio';
import Reviews from '../components/modern/Reviews';
import ContactCTA from '../components/modern/ContactCTA';
import MapSection from '../components/modern/MapSection';
import ModernFooter from '../components/modern/ModernFooter';
import SEO from '../components/modern/SEO';

// EU Funding Badge Component (OMED style - floating in corner)
const EUFundingBadge = () => (
  <Link 
    to="/palyazat"
    className="fixed top-20 md:top-28 right-2 md:right-4 z-30 bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-200 overflow-hidden"
    title="Pályázati információ"
  >
    <div className="p-1 md:p-2">
      <img 
        src="/images/Weboldalképei/kedvezmenyezetti-infoblokk-keretes.jpg" 
        alt="Széchenyi Terv Plusz - EU támogatás" 
        className="w-24 md:w-36 h-auto"
      />
    </div>
  </Link>
);

export default function ModernHomePage() {
  return (
    <>
      <SEO 
        title="XL bútor - Egyedi bútor gyártás 1989 óta | 3D tervezés, precíz kivitelezés"
        description="Egyedi bútor tervezés és gyártás saját 1500 m² műhelyben. 3D tervezés, precíz kivitelezés, 35+ év tapasztalat. Konyhabútor, szekrények, nappali bútorok. Ingyenes konzultáció!"
        keywords="egyedi bútor, bútor gyártás, 3D tervezés, konyhabútor, szekrény gyártás, lakberendezés, asztalos, lapszabászat, Budapest"
      />
      
      <div className="bg-[var(--color-bg)]">
        <ModernHeader />
        <EUFundingBadge />
        <main>
          <HeroSection />
          <KPIGrid />
          <Services />
          <Portfolio />
          <Timeline />
          <Reviews />
          <ContactCTA />
          <MapSection />
        </main>
        <ModernFooter />
      </div>
    </>
  );
}

